import styled from 'shared/utils/styled';

export const StyledTextarea = styled('textarea')(() => ({
  resize: 'none',
  outline: 'none',
}));
